import { MarketingCampaignBuilder } from "modules/marketing";
import { useParams } from "react-router-dom";

const MarketingCampaignPage = () => {
  const { campaignId } = useParams();

  return (
    <MarketingCampaignBuilder
      campaignId={campaignId === "new" ? undefined : campaignId}
    />
  );
};

export default MarketingCampaignPage;
